import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { CloseBlueIcon } from "../assets/icons/Icons";

export default function ModalContainer({ showModal, closeModal, children }) {
  
  return (
    <Modal
      open={showModal}
      onClose={closeModal}
      closeOnEsc={false}
      center
      classNames={{
        overlay: "customOverlay",
        modal: "customModal",
      }}
      animationDuration={0.1}
      closeIcon={<CloseBlueIcon />}
      styles={{ background: "red" }}
    >
      <div style={{ padding: "12px 16px" }}>
        {children}
      </div>
    </Modal>
  );
}
